import { ReactElement } from 'react';

import {
  TooltipHeader,
  TooltipName,
  TooltipRoot,
  TooltipSwatch,
  TooltipValue,
} from '../styles';

interface DonutTooltipProps {
  color: string;
  name: string;
  formattedValue: string;
  formattedPercentage: string;
}

export function DonutTooltip({
  color,
  name,
  formattedValue,
  formattedPercentage,
}: Readonly<DonutTooltipProps>): ReactElement {
  return (
    <TooltipRoot>
      <TooltipHeader>
        <TooltipSwatch $color={color} />
        <TooltipName>{name}</TooltipName>
      </TooltipHeader>
      <TooltipValue>
        {formattedValue}
        {' '}
        (
        {formattedPercentage}
        %)
      </TooltipValue>
    </TooltipRoot>
  );
}
